import { ReactNodeProps } from '../../types/reactNodeProps'

export interface Props extends ReactNodeProps {
  title: string
}

export default function Tab(props: Props) {
  return <>{props.children}</>
}
